import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  IProductBatchLocationsGetAllParams,
  IProductBatchLocationsResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IProductBatchLocationsResponse>>,
  IPathBaseParam,
  IPaginationParams & IProductBatchLocationsGetAllParams
>("stores.warehouses.productBatchLocations");

const getApis = createGetApi<
  IApiResponse<IProductBatchLocationsResponse>,
  IPathByIdParam,
  object
>("stores.warehouses.productBatchLocations");

export const productBatchLocations = {
  ...getAllApis,
  ...getApis,
};
